<template>
  <el-table-column
    prop="unit_purchase_price"
    label="Db egységár"
    align="right"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.unit_purchase_price | currency }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'unit_purchase_price',
};
</script>
